import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import { getStatusBadge } from "@src/utility/helpers/utils";
import useDateHandler from "@hooks/use-date-handler";
import { useTranslation } from "react-i18next";

export const decoColumns = ({ handleRowActions }) => {
    
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    return [
        {
            name : "Name",
            width: "300px",
            cell : row => (
                <LongNameFormatter
                    content={row.name}
                    className="fw-bold"
                    id={`health-score-name-${row._id}`}
                    max={100}/>
            )
        },
        {
            name : "Description",
            width: "200px",
            cell : row => (
                <LongNameFormatter
                    content={row.desc}
                    className="text-wrap"
                    id={`health-score-name-${row._id}`}
                    max={50}/>
            )
        },
        {
            name : "Status",
            width: "100px",
            cell : row => (
                <Badge color={getStatusBadge(row.status).color}>
                    {t(getStatusBadge(row.status).title)}
                </Badge>
            )
        },
        {
            name : "Created On",
            width: "250px",
            cell : row => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.created_at,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name: "Actions",
            cell: (row, index) => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        id={`${row._id}-edit-button`}
                        testId={`${index}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        className="text-danger"
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        testId={`${index}-delete-button`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};